//  Hero carousel 
const heroCarousel = document.querySelectorAll('.js-hero-carousel')
if (heroCarousel.length) {
  heroCarousel.forEach(function (el, index) {
    el.classList.add(`s${index}`);
    new Swiper(`.js-hero-carousel.s${index}`, {
      slidesPerView: 1,
      autoplay: (el.dataset.autoplay == 'true') ? { delay: el.dataset.speed, disableOnInteraction: false } : false,
      effect: "fade",
      a11y: false,
      // slideActiveClass: "swiper-slider-active-slide",
      fadeEffect: {
        crossFade: true
      },
      autoplayDisableOnInteraction: false,
      loop: true,
      pagination: {
        el: `.js-hero-carousel.s${index} .swiper-pagination`,
        clickable: true
      }
    })
  })
} 

// Product carousel 
const productCarousel = document.querySelectorAll('.js-proudct-carousel');
if (productCarousel.length) {
    productCarousel.forEach(function (el, index) {
    el.classList.add(`s${index}`);
    new Swiper(`.js-proudct-carousel.s${index}`, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      freeMode: true,
      mousewheel: {
          forceToAxis: true,
      },
      breakpoints: {
        0: {
          spaceBetween: 20,
        },
        769: {
            spaceBetween: 30,
        },
        1025: {
            spaceBetween: 40,
        }
    },
      pagination: {
        el: `.js-proudct-carousel.s${index} .swiper-pagination`,
        clickable: true,
      },
      navigation: {
        nextEl: `.js-proudct-carousel.s${index} .swiper-button-next`,
        prevEl: `.js-proudct-carousel.s${index} .swiper-button-prev`,
      },
    });
      const Heightselector = el.closest('.featured-collections-carousel').querySelector('.featured-collections-carousel__item.is-selected .js-proudct-carousel .swiper-slide img');
    if (Heightselector){
      const height = el.closest('.featured-collections-carousel').querySelector('.featured-collections-carousel__item.is-selected .js-proudct-carousel .swiper-slide img').offsetHeight;
      let top_position = (height / 2) + 2;
      el.querySelector('.swiper-button-next').style.top = top_position  + 'px';
      el.querySelector('.swiper-button-prev').style.top = top_position  + 'px';

      window.addEventListener('resize', function(event) {
          const height_resize = el.querySelectorAll('.swiper-slide')[0].querySelector('img').offsetHeight;
          let resize_top_position = (height_resize / 2) + 2;
          el.querySelector('.swiper-button-next').style.top = resize_top_position + 'px';
          el.querySelector('.swiper-button-prev').style.top =resize_top_position + 'px';
      }, true);
    }
  });
}

// HOT SPOT BUTTON PRODUCT TOGGLE 

const Hotspot_button = document.querySelectorAll('.hotspot-product-main .hotspot-product-items button');
const Hotspot_toggle_div = document.querySelectorAll('.hotspot-product-main .hotspot-product-items .hotspot-product-content');
Hotspot_button.forEach((button, index) => button.addEventListener("click", () =>{
  Hotspot_toggle_div.forEach((div, divIndex) => {
    if (divIndex !== index) {
      div.classList.add('hidden');
    }
  });
  Hotspot_toggle_div[index].classList.toggle('hidden');

}));
// TWO IMAGE FULL WIDTH 



// document.addEventListener('click', function(event) {
//   const isHotspotButtonClick = event.target.matches('.hotspot-product-main .hotspot-product-items button');
//   const isHotspotDivClick = event.target.matches('.hotspot-product-main .hotspot-product-items .hotspot-product-content');

//   if (!isHotspotButtonClick && !isHotspotDivClick) {
//     Hotspot_toggle_div.forEach(div => div.classList.add('hidden'));
//   }
// });


// CONTENT GRID

var ContentgridCarousel = document.querySelectorAll('.js-content-grid-carousel');
var media = window.matchMedia('(min-width: 769px)');

function initSliders() {
  if (!media.matches) {
    ContentgridCarousel.forEach(function (el, index) {
      if (!el.swiper) {
        el.classList.add(`s${index}`);
        el.swiper = new Swiper(el, {
          freeMode: true,
          mousewheel: {
            forceToAxis: true,
          },
          a11y: false,
          slidesPerView: 'auto',
          spaceBetween: 20,
          pagination: {
            el: el.querySelector('.swiper-pagination'),
            clickable: true,
          },
          navigation: {
            nextEl: el.querySelector('.swiper-button-next'),
            prevEl: el.querySelector('.swiper-button-prev'),
          },
        });
      }
    });
  }
}

function destroySliders() {
  ContentgridCarousel.forEach(el => {
    if (el.swiper) {
      el.swiper.destroy(true, true);
      el.swiper = null;
    }
  });
}

function handleMediaChange(e) {
  if (e.matches) {
    destroySliders();
  } else {
    initSliders();
  }
}

initSliders();

media.addListener(handleMediaChange);


// Image Height for container

const Container_heights = document.querySelectorAll('.two-column-with-full-text .two-column-with-full-text-wrapepr .tow-columns-items .media-wrapper-main');

function UpdateImageHeight() {
    const screenWidth = window.innerWidth;

    if (screenWidth > 1025) {
      const Two_image = document.querySelector('.two-column-with-full-text .two-column-with-full-text-wrapepr .column-1 .desktop_media .image');
      const Two_video = document.querySelector('.two-column-with-full-text .two-column-with-full-text-wrapepr .column-1 .desktop_media .video');
      let Tow_image_height;
      if (Two_image){
         Tow_image_height = Two_image.offsetHeight;
      }
      else if(Two_video){
         Tow_image_height = Two_video.offsetHeight;
      } else {
        Tow_image_height = 0;
      }
        Container_heights.forEach(container => {
            container.style.setProperty('--colomn-image-height', Tow_image_height + 'px');
        });
    } else if (screenWidth >= 767 && screenWidth <= 1024) {
      const Two_image = document.querySelector('.two-column-with-full-text .two-column-with-full-text-wrapepr .column-1 .tablet_media .image');
      const Two_video = document.querySelector('.two-column-with-full-text .two-column-with-full-text-wrapepr .column-1 .desktop_media .video');
        let Tow_image_height= 0;
      if (Two_image){
         Tow_image_height = Two_image.offsetHeight;
      }
      else if(Two_video){
         Tow_image_height = Two_video.offsetHeight;
      } else {
        Tow_image_height = 0;
      }
        Container_heights.forEach(container => {
            container.style.setProperty('--colomn-image-height', Tow_image_height + 'px');
        });
    }
}


UpdateImageHeight();

window.addEventListener('resize', function(event) {
    UpdateImageHeight();
}, true);

// container center while sticky 

const Image_content = document.querySelectorAll('.two-column-with-full-text .two-column-with-full-text-wrapepr.two-cols-sticky-text .tow-columns-items .column-content-wrapper .column-content');
const ImageWrapperHeight = document.querySelectorAll('.two-column-with-full-text .two-column-with-full-text-wrapepr.two-cols-sticky-text .tow-columns-items .column-content-wrapper');

function updateHeights() {
  if (window.innerWidth > 1025) {
      if (Image_content.length === ImageWrapperHeight.length) {
          Image_content.forEach((content, index) => {
              const contentHeight = content.offsetHeight;
              const Two_image = document.querySelector('.two-column-with-full-text .two-column-with-full-text-wrapepr .column-1 .media-wrapper-main img');
              const Tow_image_height = Two_image ? Two_image.offsetHeight : 0;
              const image_height = Tow_image_height / 2;
              const content_height = contentHeight / 2;
              ImageWrapperHeight[index].style.height = image_height + content_height + 'px';
          });
      } 
  }
}
updateHeights();

window.addEventListener('resize', function() {
    updateHeights();
}, true);

$(document).ready(function(){
  $('.stories-slider-section .stories-slider-outer').slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    rows: 0,
    dots: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 577,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  $('.featured-products-slider .product-slider-section').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    rows: 0,
    dots: true,
    arrows: true
  });
});